export default "__VITE_ASSET__e74b045e__"